import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Route, CanLoad, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { UserService } from "../_services";

declare let toastr: any;
@Injectable()
export class AccessGuard implements CanLoad {
    constructor(private router: Router) { }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        if (!environment.production) console.info("route", route);

        if (route.data && route.data.access) {
            const ra = route.data.access;
            const access = UserService.getAccess();
            const tmp = access.find(a => a.action_id == ra.action_id);

            if (!environment.production) console.info("AccessGuard", ra, access, tmp);

            if (tmp) {
                let result = true;
                if (ra.key instanceof Array) {
                    ra.key.forEach(key => {
                        console.info(key, tmp[key], result);
                        result = result && (tmp[key] == 1);
                        // result = result && tmp[key];
                    });
                }

                if (!result) {
                    if (typeof toastr.warning == "function") toastr.warning("You are not allowed to access this page.");
                    this.router.navigate(['/login']);
                }

                return result;
            } else {
                this.router.navigate(['/login']);
            }
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/access.guard.ts